/* eslint-disable */
import React, { Component, Button } from 'react';
import classNames from 'classnames';
import Loader from './LoadingSpinner';
import PermissionComponent from './PermissionComponent';
import Tooltip from './Tooltip';

export default class ActionButton extends PermissionComponent {
    renderIcon = () => {
        if (this.props.iconClass) {
            return (
                <i
                    className={`icon ${this.props.text ? 'with-text ' : ''}${
                        this.props.iconClass
                    }`}
                />
            );
        }
    };

    render() {
        if (this.props.hasOwnProperty('show') && !this.props.show) {
            return null;
        }

        const classes = classNames({
            'grouped-item': true,
            'table-action-button': true,
            'table-action-button-compact': this.props.compact ? this.props.compact : false,
            'table-action-button-loading': this.props.loading,
            'table-action-button-disable': this.props.disabled,
            active: this.props.active,
            ...(this.props.className || '')
                .split(' ')
                .reduce(
                    (result, current) => ({ ...result, [current]: true }),
                    {},
                ),
        });
        if (this.props.loading) {
            return (
                <div className={classes} id={this.props.buttonId}>
                    <Loader color="gray" size="6px" margin="6px" />
                </div>
            );
        }
        const button = (
            <button
                className={classes}
                id={this.props.buttonId}
                onClick={
                    this.props.disabled ? undefined : this.props.onAction
                }
                disabled={this.props.disabled}
            >
                {this.renderIcon()}
                {this.props.text}
            </button>
        );
        return this.renderIfPerm(
            this.props.tooltip ? (
                <Tooltip tooltip={this.props.tooltip}>{button}</Tooltip>
            ) : (
                button
            ),
        );
    }
}
